import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrAbsenceCategoryEntity } from "@odata/GeneratedEntityTypes";
import { handleCurrentTemporalPropChange } from "@odata/TemporalUtils";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";

interface IProps extends IFormViewProps<IPrAbsenceCategoryEntity, null> {
}

class AbsenceCategoryFormView extends FormViewForExtend<IPrAbsenceCategoryEntity, IProps> {
    static contextType = AppContext;
    static defaultProps = {
        title: "AbsenceCategory:FormTitle"
    };

    handleChange = (e: ISmartFieldChange): void => {
        this.props.storage.handleChange(e);
        handleCurrentTemporalPropChange(e, this.props.storage);
        this.props.storage.refresh();
    };
}

export default withPermissionContext(AbsenceCategoryFormView);